import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Link, useSearchParams } from 'react-router-dom';
import { MdFastfood } from "react-icons/md";
import imgPizza from '../../img/Pizza2.png';
import { formatPriceWithSymbol } from '../../utils/currency';
import SafeImage from '../../components/SafeImage';

function Categoria({ categoria, itens, nomeEmpresaForUrl, idEmpresa, slug, isSlugRoute, mode, handleSelectCategoria, statusLoja }) {

  const [searchParams] = useSearchParams();
  const isSalao = mode === 'salao';

  // Obtém o external_id da URL atual, se existir
  const externalId = searchParams.get('external_id');

  // Helper para construir URL de detalhe preservando query params
  const buildDetailUrl = (itemId) => {
    const base = isSlugRoute
      ? `/c/${slug}/detalhes/${itemId}`
      : `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/detalhes/${itemId}`;
    const params = new URLSearchParams();
    if (externalId) params.set('external_id', externalId);
    if (isSalao) params.set('mode', 'salao');
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
  };

  const { ref } = useInView({
    threshold: 1, // Ajuste este valor conforme necessário para melhorar a precisão
    rootMargin: "-140px 0px", // Adiciona uma margem extra para detecção
    onChange: (isVisible) => {
      //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`Categoria ${categoria._id} visível: ${isVisible} ref: ${ref}`);
      if (isVisible) handleSelectCategoria(categoria._id);
    },
  });
  //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(inView)

  return (
    <div id={categoria._id} className="mapContainerCategorias">
      <div className="title-container-mobile">
        <h2>{categoria.title}</h2>
      </div>
      <div className="itens-mobile">
        {itens
          .filter((item) => item.category_item_id === categoria._id)
          .map((item, index) => (
            <div key={item._id} className="itens-container-mobile">
              {/*<Link
                className="item-card"
                to={`/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/detalhes/${item._id}`}
                state={{ item, statusLoja }}
              >*/}
              <Link
                className="item-card"
                to={buildDetailUrl(item._id)}
                state={{ item, statusLoja, mode }}
              >
                <div ref={index === 0 || index === 1 ? ref : null} className="text-info-mobile">
                  <h4>{item.title}</h4>
                  <p className="description-mobile">{item.description}</p>
                  <div className="price-mobile">
                    <p style={{ fontSize: 14 }}>{formatPriceWithSymbol(isSalao ? (item.price_salao ?? item.price) : item.price)}</p>
                  </div>
                </div>
                <div className="image-container-mobile">
                  <div className="picture-mobile">
                    <SafeImage
                      src={item.image}
                      alt={item.title}
                      loading="lazy"
                      fallback={
                        item?.type === "pizza"
                          ? <img src={imgPizza} alt="product" />
                          : <div className="icon-fallback-mobile"><MdFastfood /></div>
                      }
                    />
                  </div>
                </div>
              </Link>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Categoria;